import get from 'lodash.get';

import { selectNewsletterOptIn } from '../../redux/auth/newsletterOptIn/selectors';
import { selectModal } from '../../redux/router/selectors';
import { email } from '../../attrs/content';

import { createDeepEqualSelector } from '../../redux/utils/selectors';

import { MODAL_NEWSLETTER_OPT_IN } from '../../constants/app';

export const selectActivated = createDeepEqualSelector(selectNewsletterOptIn, (newsletterOptIn) =>
  get(newsletterOptIn, 'success', false),
);

export const selectError = createDeepEqualSelector(selectNewsletterOptIn, (newsletterOptIn) =>
  get(newsletterOptIn, 'err', false),
);

export const selectErrorMessage = createDeepEqualSelector(selectNewsletterOptIn, (newsletterOptIn) => {
  const error = get(newsletterOptIn, 'errMsg', 'Error');

  return `Marketing opt-in failed. Please get in touch with us at ${email}. ${error}`;
});

export const selectIsLoading = createDeepEqualSelector(selectNewsletterOptIn, (newsletterOptIn) =>
  get(newsletterOptIn, 'loading', false),
);

export const selectIsVisible = createDeepEqualSelector(selectModal, (modal) => modal === MODAL_NEWSLETTER_OPT_IN);
